/* libs */
import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as ExperienceActions from "../../actions/experiencesActions";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const editNavigationLogic = createLogic({
	type: ActionTypes.EDIT_EXPERIENCE_NAVIGATION,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		//TODO: dispatch action for creating a loader
		dispatch(ControlPanelActions.showLoading());
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.put(`/experiences/${action.expId}/navigation`, action.navigation)
					.then(res => {
						dispatch(ControlPanelActions.hideLoading());
						dispatch(
							ControlPanelActions.displayQuickMessage("Navigation Saved", "success", "check-circle")
						);
						dispatch(ExperienceActions.editExperienceNavigationSuccess(res.data));
						action.submitHandler(true, res);
						done();
					})
					.catch(error => {
						dispatch(ControlPanelActions.hideLoading());
						//TODO: dispatch action for stopping loader
						dispatch(ControlPanelActions.displayError(error.message));
						action.submitHandler(false, error);
						done();
					});
			});
	},
});

export default [editNavigationLogic];
